import { useSelector } from "react-redux";
import { WHO_CAN_HIRE_SECTION } from "../../../constants/sections";
import { useWindowResize } from "../../../hooks";

const useIntroSection = () => {
    const { isMobile } = useWindowResize();
    const { activePromotion } = useSelector(state => ({
        activePromotion: state.HomeInsurance.activePromotion,
    }));
    const hasPromotion = Boolean(activePromotion);

    const handleClickLandingButton = () => {
        const element = document.getElementById(WHO_CAN_HIRE_SECTION);
        if (isMobile) {
            const prevElement = document.getElementsByClassName("landing-which-ensure");
            window.scroll({
                top:
                    prevElement[0].getBoundingClientRect().top +
                    prevElement[0].offsetHeight -
                    70,
                behavior: "smooth",
            });
        } else element.scrollIntoView({ behavior: "smooth" });
    };

    return {
        isMobile,
        hasPromotion,
        handleClickLandingButton,
    };
};

export default useIntroSection;
